import React from 'react';
import { motion } from 'framer-motion';

interface GlassCardProps {
    children: React.ReactNode;
    className?: string;
    hover?: boolean;
}

const GlassCard: React.FC<GlassCardProps> = ({
                                                 children,
                                                 className = '',
                                                 hover = true,
                                                 ...props
                                             }) => {
    return (
        <motion.div
            className={`glass-card ${className}`}
            whileHover={hover ? { y: -5, transition: { duration: 0.2 } } : {}}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            {...props}
        >
            <div className="glass-card__inner">
                {children}
            </div>
            <div className="glass-card__reflection"></div>
        </motion.div>
    );
};

export default GlassCard;